import Cookies from 'js-cookie'

const app = {
  state: {
    appCode: "000000",
    sidebar: {
      opened: true,
      withoutAnimation: false
    },
    language: Cookies.get('globalLanguage'),
    device: 'desktop'
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      // state.sidebar.opened = !state.sidebar.opened
      // state.sidebar.withoutAnimation = false
            state.sidebar.opened = true
      state.sidebar.withoutAnimation = true
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      // state.sidebar.opened = false
      // state.sidebar.withoutAnimation = withoutAnimation
         state.sidebar.opened = true
      state.sidebar.withoutAnimation = true
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('globalLanguage', language)
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js